import { createFileRoute } from "@tanstack/react-router";

import { ConsoleModelsPage, consoleModelsQueryOptions } from "@/features/console";

export const Route = createFileRoute("/_authed/_modal/console/models")({
  // Intent preload — warm the per-purpose config + catalog before the page
  // paints (fire-and-forget, never blocks navigation).
  loader: ({ context: { queryClient } }) => {
    void queryClient.ensureQueryData(consoleModelsQueryOptions());
  },
  component: ConsoleModelsPage,
});
